module.exports = __webpack_public_path__ + "static/img/101804.f0856ddc.png";